import x from "./SubHeader";

export default x;
